import { Form } from 'factorial-form'

class DiscoverabilityWidget extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      hints: 'boolean',
    })
  }
}

export default DiscoverabilityWidget
